import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Quote = React.forwardRef((props, ref) => {
    return React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-quote' }, props, { ref: ref, theme: useTheme() }));
});
Quote.displayName = 'Quote';

export { Quote };
//# sourceMappingURL=Quote.js.map
